import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'tableBuilder',
    label: 'Table Builder',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
